import { useEffect, useState } from 'react';
import { ResponsivePNG } from 'sports-react';
import CardHeader from '~/components/CardHeader/CardHeader';
import MatchupSection from '~/components/MatchupSection/MatchupSection';
import StyledComponent from '~/components/Styled/Styled';

import css from '~/components/BaseballBattingLineup/BaseballBattingLineup.scss';

interface BaseballBattingLineupProps {
  battingLineup: {
    alignment: string;
    batting_slot: string;
    position: string;
    player: {
      first_initial_and_last_name: string;
      full_name: string;
      headshots: {
        small: string;
      };
    };
  }[];
  awayTeam: string;
  homeTeam: string;
}

const BaseballBattingLineup = ({
  battingLineup,
  awayTeam,
  homeTeam,
}: BaseballBattingLineupProps) => {
  const [battingLineupParsed, setBattingLineupParsed] = useState(null);

  useEffect(() => {
    const lineupToParse = battingLineup.reduce((acc, elem) => {
      if (acc[elem.batting_slot]) {
        acc[elem.batting_slot] = {
          ...acc[elem.batting_slot],
          [elem.alignment]: { ...elem },
        };
      } else {
        acc[elem.batting_slot] = {
          [elem.alignment]: { ...elem },
        };
      }
      return acc;
    }, {});

    setBattingLineupParsed(lineupToParse);
  }, []);

  if (!battingLineupParsed) return null;

  return (
    <div className={`${css.teamStatsCard} ${css.pregameBattingLineups}`}>
      <div className={css.teamStats}>
        <MatchupSection>
          <div className={css.cardHeader}>Lineups</div>
          <div className={css.teamStats}>
            <CardHeader>
              <div className={css.awayTeamName}>{awayTeam}</div>
              <div className={css.homeTeamName}>{homeTeam}</div>
            </CardHeader>
            <div className={css.battingLineup}>
              {Object.keys(battingLineupParsed).map(battingOrderNumber => {
                const away = battingLineupParsed[battingOrderNumber].away;
                const home = battingLineupParsed[battingOrderNumber].home;

                return (
                  <div className={css.batterRow} key={battingOrderNumber}>
                    <div className={css.battingLineupAway}>
                      <ResponsivePNG
                        className={css.batterHeadshot}
                        src={away.player.headshots.small}
                        alt={away.player.full_name}
                      />
                      <div className={css.batterNameAndPos}>
                        <span>{away.player.first_initial_and_last_name}</span>
                        <span>{away.position}</span>
                      </div>
                    </div>
                    <div className={css.battingOrderNumber}>{battingOrderNumber}</div>
                    <div className={css.battingLineupHome}>
                      <ResponsivePNG
                        className={css.batterHeadshot}
                        src={home.player.headshots.small}
                        alt={home.player.full_name}
                      />
                      <div className={css.batterNameAndPos}>
                        <span>{home.player.first_initial_and_last_name}</span>
                        <span>{home.position}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </MatchupSection>
      </div>
    </div>
  );
};

export default StyledComponent(BaseballBattingLineup, [css]);
